import React from 'react';
import './Blog.css';

const Blog = () => {
    return (
        <div className="container pt-5 pb-5">    
            <h2 className="text-white mt-5">Blog System Comming Soon.....</h2>
        </div>
    );
};

export default Blog;